import { parseControlFormatFields, RawControlFormatFields } from '../parseControlFormatFields';

export function isRelatedDocumentField(formatting: RawControlFormatFields) {
    return parseControlFormatFields(formatting).isRelatedDocumentField;
}
